import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { KiVerbindung, KiVerbindungSpeichern, KiVerbindungTestErgebnis } from '../models/ki-verbindung.model';

@Injectable({ providedIn: 'root' })
export class KiVerbindungService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  get(projectId: string): Observable<KiVerbindung> {
    return this.http.get<KiVerbindung>(`${this.base}/${projectId}/ki-verbindung`);
  }

  speichern(projectId: string, request: KiVerbindungSpeichern): Observable<KiVerbindung> {
    return this.http.put<KiVerbindung>(`${this.base}/${projectId}/ki-verbindung`, request);
  }

  testen(projectId: string, request: KiVerbindungSpeichern): Observable<KiVerbindungTestErgebnis> {
    return this.http.post<KiVerbindungTestErgebnis>(`${this.base}/${projectId}/ki-verbindung/test`, request);
  }
}
